<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk com_pop" style="max-width: 1400px">
        <div class="pop_tit _flex">
            <p>{{ state.boardDetail.title }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="date_wrap">
            <template v-if="state.boardDetail.state == 2">
                <span class="state_tag">진행중</span>
            </template>
            <template v-else-if="state.boardDetail.state == 1">
                <span class="state_tag waiting">대기중</span>
            </template>
            <template v-else>
                <span class="state_tag finish">마감</span>
            </template>
            <div class="collection_period">
                <span>
                    <img src="img/time_icon.png" alt="" />
                    모집기간
                </span>
                <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.recruitStartDate), ".") }}</span>
                <em>-</em>
                <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.recruitEndDate), ".") }}</span>
            </div>
            <div class="end_point">
                <span>
                    <img src="img/time_icon.png" alt="" />
                    신청종료일
                </span>
                <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.applyDate), ".") }}</span>
            </div>
            <div class="activity_duration" v-if="state.boardDetail.activeStartDate && state.boardDetail.activeEndDate">
                <span>
                    <img src="img/cal_icon.png" alt="" />
                    활동기간
                </span>
                <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.activeStartDate), ".") }}</span>
                <em>-</em>
                <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.activeEndDate), ".") }}</span>
            </div>
        </div>
        <div class="list_container _flex">
            <div class="left">
                <div class="num_wrap">
                    <span>신청인원</span>
                    <div>
                        <span>{{ state.listForApply.recordsTotal }} 명</span>
                        <button type="button" class="excel_btn icon_wrap"><img src="img/excel_icon.png" alt="" @click="downloadFile(1)" /></button>
                    </div>
                </div>
                <div class="common_table custom_scroll">
                    <table>
                        <colgroup>
                            <col style="width: 35px" />
                            <col style="width: 70px" />
                            <col style="width: 30px" />
                            <col style="width: 60px" />
                            <col style="width: 46px" />
                            <col style="width: 40px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>번호</th>
                                <th>이름</th>
                                <th>성별</th>
                                <th>전화번호</th>
                                <th>신청일</th>
                                <th>신청서</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="state.listForApply.recordsTotal > 0">
                                <tr v-for="(item, idx) in state.applyList" :key="item.idx">
                                    <td>{{ (state.pageForApply - 1) * state.sizeForApply + (idx + 1) }}</td>
                                    <td>{{ item.memberVO?.memberVO.name }}</td>
                                    <td>{{ strGender(item.memberVO?.gender) }}</td>
                                    <td>
                                        {{ CommonUtils.convertPhoneNum(item.memberVO?.phone).phoneNum1 }}-{{
                                            CommonUtils.convertPhoneNum(item.memberVO?.phone).phoneNum2
                                        }}-{{ CommonUtils.convertPhoneNum(item.memberVO?.phone).phoneNum3 }}
                                    </td>
                                    <td>{{ CommonUtils.dateFormatYY(new Date(item.createDate), ".") }}</td>
                                    <td class="cnt p_5">
                                        <button type="button" class="table_btn _blue" @click="showAnswer(item)">보기</button>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="6"><div class="tb_subject" style="text-align: center; width: 100%">신청 인원이 없습니다.</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <PageBtn
                    v-if="state.listForApply.recordsTotal > 0"
                    :currentPage="state.pageForApply"
                    :totalLength="state.totalLengthForApply"
                    :perPage="state.sizeForApply"
                    :data="state.dataForApply"
                    @onPaging="handlePageChangeForApply"
                ></PageBtn>
            </div>

            <!-- 선발인원 -->
            <div class="right">
                <div class="num_wrap">
                    <span>선발인원</span>
                    <div>
                        <span>{{ state.listForPick.recordsTotal }} 명</span>
                        <button type="button" class="excel_btn icon_wrap"><img src="img/excel_icon.png" alt="" @click="downloadFile(2)" /></button>
                    </div>
                </div>
                <div class="common_table custom_scroll">
                    <table>
                        <colgroup>
                            <col style="width: 35px" />
                            <col style="width: 70px" />
                            <col style="width: 30px" />
                            <col style="width: 60px" />
                            <col style="width: 46px" />
                            <col style="width: 40px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>번호</th>
                                <th>이름</th>
                                <th>성별</th>
                                <th>전화번호</th>
                                <th>신청일</th>
                                <th>신청서</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="state.listForPick.recordsTotal > 0">
                                <tr v-for="(item, idx) in state.pickList" :key="item.idx">
                                    <td>{{ (state.pageForPick - 1) * state.sizeForPick + (idx + 1) }}</td>
                                    <td>{{ item.memberVO?.memberVO.name }}</td>
                                    <td>{{ strGender(item.memberVO?.gender) }}</td>
                                    <td>
                                        {{ CommonUtils.convertPhoneNum(item.memberVO?.phone).phoneNum1 }}-{{
                                            CommonUtils.convertPhoneNum(item.memberVO?.phone).phoneNum2
                                        }}-{{ CommonUtils.convertPhoneNum(item.memberVO?.phone).phoneNum3 }}
                                    </td>
                                    <td>{{ CommonUtils.dateFormatYY(new Date(item.createDate), ".") }}</td>
                                    <td class="cnt p_5">
                                        <button type="button" class="table_btn _blue" @click="showAnswer(item)">보기</button>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="6"><div class="tb_subject" style="text-align: center; width: 100%">선발 인원이 없습니다.</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <PageBtn
                    v-if="state.listForPick.recordsTotal > 0"
                    :currentPage="state.pageForPick"
                    :totalLength="state.totalLengthForPick"
                    :perPage="state.sizeForPick"
                    :data="state.dataForPick"
                    @onPaging="handlePageChangeForPick"
                ></PageBtn>
            </div>
        </div>
        <div>
            <textarea name="" id="" class="custom_scroll" placeholder="내용을 입력해주세요." v-model="state.boardDetail.memo"></textarea>
        </div>
        <div class="_flex _center btn_wrap">
            <button class="submit_btn _130 _main_blue" @click="save()">저장</button>
        </div>
    </div>
    <AnswerModal
        v-if="state.isShowAnswer"
        :answerInfo="state.answerInfo"
        @close="state.isShowAnswer = false"
        @callback="
            state.isShowAnswer = false;
            getApplyList();
            getPickList();
        "
    ></AnswerModal>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode, PageBtn, AnswerModal } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
        },
        emits: ["close", "saveForMemo", "viewSign", "exportSign", "exportExcelForActivityApply"],
        components: {
            PageBtn,
            AnswerModal,
        },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                dataForApply: {} as any,
                dataForPick: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,

                boardDetail: {} as any,

                listForApply: {} as any,
                pageForApply: 1 as number,
                sizeForApply: 10 as number,
                totalPageForApply: 1 as number,
                totalLengthForApply: 0 as number,

                listForPick: {} as any,
                pageForPick: 1 as number,
                sizeForPick: 10 as number,
                totalPageForPick: 1 as number,
                totalLengthForPick: 0 as number,

                applyList: {} as Array<any>,
                pickList: {} as Array<any>,

                isShowAnswer: false as boolean,
                answerInfo: {} as any,
            });

            onMounted(() => {
                boardDetail();
                getApplyList();
                getPickList();
            });

            onUnmounted(() => {});

            const closeModal = () => emit("close");

            const handlePageChangeForApply = (page: number) => {
                state.pageForApply = page;
                getApplyList();
            };

            const handlePageChangeForPick = (page: number) => {
                state.pageForPick = page;
                getPickList();
            };

            const save = () => {
                const param: types.ReqBoardForMemoForModify = {
                    idx: props.idx,
                    memo: state.boardDetail.memo,
                };
                emit("saveForMemo", param);
            };

            const downloadFile = (type: number) => {
                emit("exportExcelForActivityApply", type, props.idx);
            };

            const boardDetail = async () => {
                const res = await apiService.board.detail(1, props.idx);

                if (res.returnCode === 0) {
                    state.boardDetail = res.data;
                }
            };

            const getApplyList = async () => {
                const param: types.ReqBoardApplyList = {
                    searchText: "",
                    searchType: "",
                    page: state.pageForApply,
                    size: state.sizeForApply,
                    boIdx: props.idx,
                };
                const res = await apiService.board.listForApply(props.idx, param);
                if (res.returnCode === 0) {
                    state.listForApply = res.list;
                    state.applyList = res.list.data;
                    state.totalPageForApply = res.list.totalPages;
                    state.totalLengthForApply = res.list.recordsTotal;
                } else {
                    state.listForApply = [];
                    state.totalPageForApply = 0;
                    state.totalLengthForApply = 0;
                }
            };

            const getPickList = async () => {
                const param: types.ReqBoardApplyList = {
                    searchText: "",
                    searchType: "",
                    page: state.pageForPick,
                    size: state.sizeForPick,
                    boIdx: props.idx,
                };

                const res = await apiService.board.listForPickApply(props.idx, param);
                if (res.returnCode === 0) {
                    state.listForPick = res.list;
                    state.pickList = res.list.data;
                    state.totalPageForPick = res.list.totalPages;
                    state.totalLengthForPick = res.list.recordsTotal;
                } else {
                    state.listForPick = [];
                    state.totalPageForPick = 0;
                    state.totalLengthForPick = 0;
                }
            };

            const strGender = (val: string) => {
                switch (val) {
                    case "M":
                        return "남자";
                    case "F":
                        return "여자";
                    default:
                        return "기타";
                }
            };

            const viewSign = async (param: string) => {
                emit("viewSign", param);
            };

            const exportSign = async (param: string) => {
                emit("exportSign", param);
            };

            const showAnswer = (item: any) => {
                state.answerInfo = item;
                state.answerInfo.name = item.memberVO?.memberVO.name;
                state.isShowAnswer = true;
            };

            return {
                state,
                closeModal,
                props,
                CommonUtils,
                save,
                strGender,
                handlePageChangeForApply,
                handlePageChangeForPick,
                viewSign,
                exportSign,
                downloadFile,
                getApplyList,
                getPickList,
                showAnswer,
            };
        },
    };
</script>

<style scoped>
    .applicant_chk .common_table {
        overflow-y: auto;
        max-height: calc(100vh - 650px);
    }
</style>
